import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from '../../Basic/Select';
import CheckBox from '../../Basic/CheckBox';
import RadioSection from '../../Sections/RadioSection';
import FortisButton from '../../Basic/FortisButton';
import { selectedAddress } from '../../../selectors/ServiceAddress';
import util from '../../../lib/util';
import AddressToString from '../AddressToString';
import LinkButton from '../../Basic/LinkButton';
import TextArea from '../../Basic/TextArea';
import { nextStepClicked } from '../../../actions';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
//import { Address2Validation } from '../Address2';
class ConfirmAddress extends React.Component {
    constructor() {
        super();
        this.state = { confirmClicked: false, selectedAddressId: 0, unitNumber: '' };
    }
    componentWillReceiveProps(p) {
        if (p.selectedAddressId !== this.state.selectedAddressId) {
            this.setState({ selectedAddressId: p.selectedAddressId });
            this.setState({ confirmClicked: false });
            p.dispatch({ type: 'checkbox', name: 'checkConfirmAddress', value: 0 });
        }
        if (p.unitNumber !== this.state.unitNumber) {
            this.setState({ unitNumber: p.unitNumber });
            if (!p.isResume || this.state.isResumInitDone) {
                this.setState({ confirmClicked: false });
                p.dispatch({ type: 'checkbox', name: 'checkConfirmAddress', value: 0 });
            } else {
                this.setState({ confirmClicked: true });
                this.setState({ isResumInitDone: true });
            }
        }
        if (p.isAddressConfirmed && !this.state.confirmClicked) {
            if (p.selectedAddressId == -1 || p.selectedAddressId == -2) {
                let validators = [['siteAddress_streetNumber', p => p.streetNumber, "Street number"],
                ['siteAddress_streetName', p => p.streetName, "Street name"],
                ['siteAddress_city', p => p.city, "City"],
                ['siteAddress_state', p => p.state, "Province"],
                ['siteAddress_zip', p => p.zip, "Postcode / zip"],
                ['addressList', p => p.selectedAddressId != -2, "Address"]];
                // to fix later
                //    if (p.selectedAddressId == -1)
                //            validators = [...validators, ...Address2Validation('siteAddress')];
                if (util.validate(validators, p, p.formError)) {
                    this.checkForOffRamp(p);
                } else {
                    this.setState({ confirmClicked: false });
                    p.dispatch({ type: 'checkbox', name: 'checkConfirmAddress', value: 0 });
                }
            }
            else {
                this.checkForOffRamp(p);
            }
        }
    }
    checkForOffRamp = (p) => {
        let model = {
            Address: p.selectedAddress,
            IsSiteAddressNotFromGIS: (p.selectedAddressId == -1)
        };
        this.setState({ confirmClicked: true });
        p.dispatch({ type: 'CHECK_OFFRAMP', model });
    }
    onNextClick = () => {
        const p = this.props;
        let validators = [];
        // if none address selected
        if (p.selectedAddressId == -1 && !p.isProjectOffRamped) {
            // One array is enough
            validators = [['siteAddress_streetNumber', p => p.streetNumber, "Street number"],
            ['siteAddress_streetName', p => p.streetName, "Street name"],
            ['siteAddress_city', p => p.city, "City"],
            ['siteAddress_state', p => p.state, "Province"],
            ['siteAddress_zip', p => p.zip, "Postcode / zip"]];
        }
        //if choosing other reason for removing natural gas(reasonType == "2"), should provide description for it(otherReasons)
        if (p.reasonType == 2)  // create an enum 
            validators = [...validators, ['otherReasons', p => p.otherReasons, "Reason"]];
        //if choose no(vacantType == "2") for building is currency vacant, should acknowledge(checkConfirm == "1") that they will not have gas after service removed
        if (p.vacantType == '2')
            validators = [...validators, ['checkConfirm', p => (p.checkConfirm == 1)]];
        //should select "Is the building currently vacant?" yes(1) or no(2)
        validators = [...validators, ['vacantType', p => p.vacantType]];

        if (util.validate(validators, p, p.formError)) {
            util.trackGoogleAnalytics(p.pageName, 'Service address', 'Without offramp');
            if (p.premiseNumber)
                p.dispatch({ type: 'READ_PREMISE', premiseNumber: p.premiseNumber });
            p.onNextStepClicked(1);
        }
    }
    render() {
        const p = this.props;
        if (!p.addressList) return null;

        const serviceAddress = window.osa && window.osa.lookup && window.osa.lookup.serviceAddress;
        const reasonTypes = serviceAddress && serviceAddress.reasonTypes;
        const vacantTypes = serviceAddress && serviceAddress.vacantTypes;
        const demolishReasonTypes = serviceAddress && serviceAddress.demolishReasonTypes;

        const reasonTypeSelect = { ...reasonTypes, name: 'reasonType' };
        const vacantTypeSelect = { ...vacantTypes, name: 'vacantType' };
        const demolishReasonTypeSelect = { ...demolishReasonTypes, name: 'demolishReasonType' };
        const lookup = window.osa && window.osa.lookup;
        const contactUsPhoneText = lookup.common && lookup.common.contactUsPhoneText;
        // move constant strings to lookups
        // console.log(serviceAddress);
        const note = serviceAddress ? '<b>Note:</b> ' + serviceAddress.note + contactUsPhoneText : null;

        return (
            <div>
                <CheckBox name="checkConfirmAddress" title={serviceAddress && serviceAddress.confirmAddress} required />
                <div dangerouslySetInnerHTML={{ __html: note }} />
                {p.isAddressConfirmed ?
                    <div className="form-group">
                        <div className="row">
                            <div className="col-sm-6">
                                <Select {...reasonTypeSelect} />
                            </div>
                        </div>
                        {p.isDemolishSelected ?
                            <div className="row">
                                <div className="col-sm-6">
                                    <Select {...demolishReasonTypeSelect} />
                                </div>
                            </div>
                            :
                            <div className="row">
                                <br />
                                <div className="col-sm-6">
                                    <TextArea title={serviceAddress.otherReason} name="otherReasons" required />
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="col-sm-6">
                                <RadioSection {...vacantTypeSelect} required />
                            </div>
                        </div>
                        {p.isBuildingNotVacant ?
                            <div className="row">
                                <div className="col-sm-12">
                                    <CheckBox name="checkConfirm" title={serviceAddress.acknowledge} required value={0} />
                                </div>
                            </div> : null}
                        <div className="row">
                            <div className="col-sm-12">
                                <h4 className="text-available" >
                                    <AddressToString message={serviceAddress.confirmRemoval} {...p.selectedAddress} />
                                </h4>
                                <ButtonToolbar  style={{display: "inline-flex"}}>
                                <FortisButton text="Next step" onClick={this.onNextClick} />
                                <LinkButton text="Cancel" onClick={p.onCancelClick} />
                                </ButtonToolbar>
                            </div>
                        </div>
                    </div> : null}
            </div>
        );
    }
}
ConfirmAddress.propTypes = {
    isAddressConfirmed: PropTypes.bool,
    isDemolishSelected: PropTypes.bool,
    isBuildingNotVacant: PropTypes.bool,
    onNextClick: PropTypes.func,
    reasonTypes: PropTypes.object,
    parcel: PropTypes.object,
    vacantTypes: PropTypes.object,
    demolishReasonTypes: PropTypes.object,
    selectedAddress: PropTypes.object,
    otherReasons: PropTypes.string,
    vacantType: PropTypes.string,
    reasonType: PropTypes.number,
    checkConfirm: PropTypes.number,
    streetNumber: PropTypes.string,
    streetName: PropTypes.string,
    unitNumber: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    selectedAddressId: PropTypes.number,
    premiseNumber: PropTypes.string
};


function mapDispatchToProps(dispatch) {
    return {
        onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    };
}
function mapStateToProps(state) {
    return {
        unitNumber: state.form.unitNumber,
        isAddressConfirmed: state.form.checkConfirmAddress === 1,
        isDemolishSelected: (state.form.reasonType == 1),
        isBuildingNotVacant: state.form.vacantType && (state.form.vacantType == '2'),
        selectedAddress: selectedAddress(state),
        selectedAddressId: state.form.addressList,
        otherReasons: state.form.otherReasons,
        vacantType: state.form.vacantType,
        reasonType: state.form.reasonType,
        checkConfirm: state.form.checkConfirm,
        streetNumber: state.form.siteAddress_streetNumber,
        streetName: state.form.siteAddress_streetName,
        city: state.form.siteAddress_city,
        state: state.form.siteAddress_state,
        zip: state.form.siteAddress_zip,
        pageName: state.gas.pageName,
        premiseNumber: state.gas.parcel && state.gas.parcel.data.premiseInfo && state.gas.parcel.data.premiseInfo.premiseNumber,
        isResume: state.gas.isResume
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAddress);

